import React, { useState } from 'react';
import PortfolioCard from '../componentes/PortfolioCard';
import projects from '../data/projects';

function PortfolioView() {
    const [showMore, setShowMore] = useState(false);
    return (
        <section className="work-section container section" id="work" tabIndex="-1" aria-labelledby="work-title">
            <div className="section-heading">
                <div><p className="eyebrow">01 / Selected work</p><h2 id="work-title">Built to solve<br /><em>real problems.</em></h2></div>
                <p>Financial workflows, enterprise platforms, and tools that make everyday work a little easier.</p>
            </div>
            <div className="project-grid">
                {projects.slice(0, 3).map((project, index) => <PortfolioCard key={project.id} project={project} featured={index === 0} index={index} />)}
            </div>
            <div className="more-work-heading">
                <p>There’s more where that came from.</p>
                <button className="text-link" type="button" aria-expanded={showMore} aria-controls="more-projects" onClick={() => setShowMore(!showMore)}>{showMore ? 'Show fewer projects' : 'Explore 4 more projects'} <span aria-hidden="true">{showMore ? '−' : '+'}</span></button>
            </div>
            <div className="project-grid more-projects" id="more-projects" hidden={!showMore}>
                {showMore && projects.slice(3).map((project, index) => <PortfolioCard key={project.id} project={project} index={index + 3} />)}
            </div>
        </section>
    );
}

export default PortfolioView;
